import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'word-count-text',
  template: `<span class="h5-sm text-d75 demi-bold upperCase pl-2"><ng-content></ng-content></span>
  `,
  styleUrls: ['./word-count-text.component.css']
})
export class WordCountTextComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
